import React, { useEffect, useState } from "react";
import { Column } from "devextreme-react/data-grid";
import { LVGridCarga } from "../../Componentes/Basicos/LVGridCarga";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import ComboTodosDashboardFalta from "../../Componentes/Compuestos/Combos/ComboTodosDashboardFalta";
import ComboTodosMenuesFalta from "../../Componentes/Compuestos/Combos/ComboTodosMenuesFalta";
import ComboAbmEexPersonas from "../../Componentes/Compuestos/Combos/ComboAbmEexPersonas";
import { function_TODOS_Dashboard_Permisos_Eliminar, function_TODOS_Dashboard_Permisos_Insertar } from "neftis7_apicaller/src/funciones/TODOS_Dashboard";
import { function_TODOS_Menues_Visibilizar_Eliminar, function_TODOS_Menues_Visibilizar_Insertar } from "neftis7_apicaller/src/funciones/TODOS_Menues_Visibilizar";

export const Permisos = () => {
  const [dataMenues, setDataMenues] = useState([])
  const [dataWidgets, setDataWidgets] = useState([])
  const [reload, setReload] = useState(false)
  const [idPersona, setIdPersona] = useState(0)
  const [idItem, setIdItem] = useState(0)
  const [metroTileItem, setMetroTileItem] = useState("")
  const { TODOS_Menues_Visibilizar: { function_TODOS_Menues_Visibilizar_Listar } } = require('neftis7_apicaller');
  const { TODOS_Dashboard: { function_TODOS_Dashboard_Permisos_ListarPorPersona } } = require('neftis7_apicaller');

  useEffect(() => {
    getData()
  }, [idPersona]);

  const getData = async () => {
    try {
      setReload(true)

      if (idPersona > 0) {
        const resultMenues = await function_TODOS_Menues_Visibilizar_Listar(idPersona)
        setDataMenues(resultMenues.data)

        const resultWidgets = await function_TODOS_Dashboard_Permisos_ListarPorPersona(idPersona)
        setDataWidgets(resultWidgets.data)
      }

      setReload(false)
    } catch (error) {
      alert(error);
    }
  }

  const onValueChangedPersonas = async (objeto) => {
    setIdPersona(objeto.value)
  };

  const onValueChangedWidget = async (objeto) => {
    setIdItem(objeto.value)
  };

  const onValueChangedMenu = async (objeto) => {
    setMetroTileItem(objeto.value)
  };

  const onClickAgregarMenu = async () => {
    await function_TODOS_Menues_Visibilizar_Insertar(metroTileItem, idPersona)

    getData()
  }

  const onClickAgregarWidget = async () => {
    await function_TODOS_Dashboard_Permisos_Insertar(idItem, idPersona)

    getData()
  }

  const onRowRemovedWidget = async (e) => {
    const idItemBorrar = e.data.IdItem;
    try {
      await function_TODOS_Dashboard_Permisos_Eliminar(idItemBorrar, idPersona)

      getData();
    } catch (error) {
      alert("Error eliminando el item:" + error);
    }
  };

  const onRowRemovedMenu = async (e) => {
    const metroTileItemBorrar = e.data.MetroTileItem;
    
    try {
      await function_TODOS_Menues_Visibilizar_Eliminar(metroTileItemBorrar, idPersona)

      getData();
    } catch (error) {
      alert("Error eliminando el item:" + error);
    }
  };

  return (
    <PaginaCarga
      Titulo="PERMISOS"
    >
      <div className="LV-GroupBox-div" style={{ display: 'flex', alignItems: 'left', marginBottom: '20px' }}>
        <ComboAbmEexPersonas onValueChanged={onValueChangedPersonas} value={idPersona} />
      </div>

      <div className="LV-GroupBox-div"
        style={{ display: 'flex', alignItems: 'left', gap: '5px' }} >

        <div className="LV-GroupBox-div"
          style={{ alignItems: 'left', gap: '5px', width: '50%' }} >
          <div
            style={{ display: 'flex', alignItems: 'left', gap: '5px', width: '100%' }} >
            <ComboTodosMenuesFalta
              ancho="400"
              idPersona={idPersona}
              reloadData={reload}
              value={metroTileItem}
              onValueChanged={onValueChangedMenu} />
            <LVButtonAccion Texto={"AGREGAR"} onClick={onClickAgregarMenu} />
          </div>

          <br />
          <br />

          {dataMenues.length > 0 ? (
            <LVGridCarga
              dataSource={dataMenues}
              id="MetroTileItem"
              keyExpr="IdMenu"
              height={400}
              onRowRemoved={onRowRemovedMenu}
            >
              <Column caption="Código" dataField="IdMenu" width="80" alignment="Right" dataType="string" />
              <Column caption="Menu" dataField="MetroTileItem" width="80" alignment="Left" dataType="string" visible={false} />
              <Column caption="Menu" dataField="NombreHeredado" minWidth={200} width="100%" alignment="Right" dataType="string" />
            </LVGridCarga>
          ) : (
            <div className="card-body text-center">
              <h5 className="card-title">No hay datos</h5>
            </div>
          )}
        </div>

        <div className="LV-GroupBox-div"
          style={{ alignItems: 'left', gap: '5px', width: '50%' }} >
          <div
            style={{ display: 'flex', alignItems: 'left', gap: '5px', width: '100%' }} >
            <ComboTodosDashboardFalta
              ancho="400"
              idPersona={idPersona}
              reloadData={reload}
              value={idItem}
              onValueChanged={onValueChangedWidget} />
            <LVButtonAccion Texto={"AGREGAR"} onClick={onClickAgregarWidget} />
          </div>

          <br />
          <br />

          {dataWidgets.length > 0 ? (
            <LVGridCarga
              dataSource={dataWidgets}
              id="gridContainer"
              keyExpr="IdItem"
              height={400}
              onRowRemoving={onRowRemovedWidget}
            >
              <Column caption="Código" dataField="IdItem" width="80" alignment="Right" dataType="number" />
              <Column caption="Descripción" dataField="Descripcion" minWidth={200} width="100%" alignment="Left" dataType="string" />
            </LVGridCarga>
          ) : (
            <div className="card-body text-center">
              <h5 className="card-title">No hay datos</h5>
            </div>
          )}
        </div>
      </div>
    </PaginaCarga >
  );
};
